<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2V22" stroke="#00B9FF" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M7 7C7 8.657 8.343 10 10 10H14C15.657 10 17 8.657 17 7" stroke="#00B9FF" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M7 17C7 15.343 8.343 14 10 14H14C15.657 14 17 15.343 17 17" stroke="#00B9FF" stroke-width="1.5" stroke-linecap="round"/>
    <circle cx="12" cy="12" r="1.5" fill="#00B9FF"/>
  </svg>
</template>

<script>
export default {
  name: 'IconBiotech'
}
</script>
